module.exports = __webpack_public_path__ + "static/img/y_szcz4.dbb3a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_szcz4.png
// module id = UnIu
// module chunks = 73